<template>
  <el-dialog
    title="服務條款與隱私權政策"
    :visible.sync="$parent.dialogTermsVisible"
    width="80%"
    :before-close="handleClose">
    <div class="terms_info">
      <p>親愛的用戶您好，歡迎使用鹿路運輸科技平台，為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的權益服務條款</p>
      <p>請詳細閱讀以下權益條款，本條款訂立的目的，是為了保護本公司會員的利益，並作為本公司與會員間會員服務提供權利義務關係之依據，當您完成相關基本資料(含姓名、聯絡電話、出生日期、性別等資料)之提供進入APP，即正式成為本公司會員，並於開始使用本公司所提供之會員服務時，即視為已知悉及完全同意本條款的所有約定：</p>
      <p>一、 個人資料蒐集及利用</p>
      <p>依照個人資料保護法第八條規定，對於客戶資料之蒐集、處理、利用等，須告知您相關事項如下，</p>
      <p>請詳閱：</p>
      <p>(一) 蒐集目的：本公司為商業與技術資訊、本公司客戶管理、會員管理、行銷、資訊與資料管理、統計調查與分析、其他合於營業登記項目或章程所定業務之需要等目的，蒐集並於下述目的範圍內利用您所提供之個人資料：040 行銷、090 消費者、客戶管理與服務、098 商業與技術資訊、135 資(通)訊服務、136 資(通)訊與資料庫管理、137 資通安全與管理、148 網路購物及其他電子商務服務、150 輔助性與後勤支援管理、157 調查、統計與研究分析、173 其他公務機關對目的事業之監督管理、176 其他自然人基於正當性目的所進行個人資料蒐集處理及利用</p>
      <p>(二) 本公司會在使用本服務的必要範圍內收集使用者的個人資料，包括但不限於：</p>
      <p>•	姓名；</p>
      <p>•	電子郵件地址；</p>
      <p>•	出生日期；</p>
      <p>•	帳單地址；</p>
      <p>•	銀行帳戶和付款資訊；</p>
      <p>•	電話號碼；</p>
      <p>•	性別；</p>
      <p>•	與您用來存取本服務或本平台的裝置相關資訊或該裝置所傳送出的資訊；</p>
      <p>•	與您的人際網路及與您互動的人及其帳號有關的資訊；</p>
      <p>•	您與我們分享的照片、錄音或影片；</p>
      <p>•	基於我們的盡職調查、身分確認或預防詐欺等目的所要求的政府機關核發之證明或其他資訊；</p>
      <p>•	當使用者註冊使用本服務或本平台及使用者使用本服務或本平台時所提供有關使用者的其他任何資訊，以及使用者如何使用本服務或本平台的相關資訊</p>
      <p>•	彙總使用者互動內容的相關資訊。</p>
      <p>(三) 利用期間、地區、對象及方式：</p>
      <p>1.期間：使用者要求停止使用或本公司停止提供服務之日為止。</p>
      <p>2.地區：使用者個人資料將用於台灣地區。</p>
      <p>3.利用對象及方式：當您為本公司客戶時，本公司基於服務之提供而取得您的基本資料，為提供您更完善、多元的服務以及更好之服務品質，我們將會在法令許可或您同意下，僅將您的資料使用在您所需的個別服務、學術研究、其他諮詢、顧問服務及本公司所舉辦的行銷活動上，以提供您所需的行銷活動及相關優惠訊息給您，</p>
      <p>二、個人資料揭露對象</p>
      <p>本公司絕對不會任意出售、交換、出租或以其他變相之方式，將您的個人資料揭露與其他團體或個人。惟有下列三種情形，本公司會與第三者共用您的個人資料。</p>
      <p>(一)經過您的事前同意或授權允許時。</p>
      <p>(二)司法單位或其他主管機關經合法正式的程序要求時。</p>
      <p>(二)為提供您其他服務或優惠權益，需要與提供該服務或優惠之第三者共用您的資料時，我們會在活動                  時提供充分說明並告知，您可以自由選擇是否接受這項服務或優惠。</p>
      <p>(四)當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</p>
      <p>三、依個人資料保護法第三條規定，您得就其所提供之個人資料行使下列權利：</p>
      <p>查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用及請求刪除，您如欲行使上述權利，可與本服務客服連絡進行申請。</p>
      <p>四、使用者權限</p>
      <p>(一)您可隨時於本服務上確認個人資料，若您的個人資料有變更、或發現個人資料不正確，可以向本公司要求修改或更正。 </p>
      <p>(二)您亦可要求本公司刪除、停止處理或利用您的個人資料。本公司將僅於法令許可之範圍內繼續保留、處理及利用您的個人資料。</p>
      <p>(三)您於本網站所有發文以及相關言論本公司有權修改、再製、刪除</p>
      <p>(四)您可自由選擇是否提供某些個人資料予本公司，惟若您未提供該等資料或提供給本公司的資料不完全，您可能無法使用本服務之部分功能。</p>
      <p>五、個人資料安全</p>
      <p>本公司將採取適當安全防護措施以防止未經您授權的接近使用、變更、重製、揭露、或刪除您的個人資料或您於本服務中之互動資料。但請注意，您的個人資料仍有可能因本公司的安全防護措施遭破壞而發生上述情事。</p>
      <p>六.  有關安全性和第三方網站的免責聲明</p>
      <p>(一)我們不保證您在第三方網站上提供之個人資料及/或其他資訊的安全性。為維護我們所擁有或控制與您有關之個人資料的安全性，我們確實實施了各種安全措施。您的個人資料包含在安全網路之後，只有具有該系統之特殊存取權且必須對個人資料保密的有限人員可以存取。當您下訂單或存取個人資料時，我們會提供安全伺服器以供使用。您提供的所有個人資料或敏感資訊都會以加密方式存放在我們的資料庫中，只有上述人員可以存取。</p>
      <p>(二)為嘗試提供更高的價值，我們可能會選擇將各種第三方網站連結至本平台，或是將第三方網站放在本平台框架中。我們可能也會參與聯合品牌和其他關係，以便為訪客提供電子商務及其他服務與功能。所連結的網站有個別和獨立的隱私權政策及安全措施。即使該第三方與我們有關，我們對於這些連結網站也沒有控制權，而且每一個連結網站都有不受我們約束的個別隱私權和資料收集作法。我們可能不會收到由聯合品牌夥伴或第三方網站 (即使是在我們的本網站上或透過我們的本平台提供) 所收集的資料。</p>
      <p>(三)因此，我們對於這些連結網站的內容、安全措施 (或缺乏該安全措施) 及活動，沒有任何責任或義務。這些連結網站只是為了方便起見而提供，因此當您存取這些網站時，應自行承擔風險。儘管如此，我們仍設法保護本平台及置於各網站之連結的完整性，因此歡迎提出與這些連結網站相關的意見 (包括但不限於特定連結無法運作的狀況)。</p>
      <p>七、Cookie之使用</p>
      <p>(一)當您使用本公司相關網路服務時，網站伺服器會自動接收並紀錄您瀏覽器上的伺服器數值，包括網路協定位址（IP Address）、Cookies 資料、瀏覽及點選網頁紀錄等，以作為本公司增進網站服務的參考依據。</p>
      <p>(二)為了提供您最佳的服務，本公司網站會使用第三網頁分析服務在您的電腦設定並取用本公司的Cookies，以追蹤您在本公司網站的活動。</p>
      <p>八、 本政策修訂</p>
      <p>本公司保留隨時修訂本政策之權利，本公司會將修訂之內容放置於本服務-隱私權政策上，以便您的查閱，如您繼續使用本服務，將視為您已同意本公司對於本政策之修訂。本公司保留於任何時點，不經通知隨時修改或暫時或永久停止繼續提供本服務(或其任一部分)的權利，不另行個別通知，使用者可以隨時在本服務上詳閱修訂後的隱私權聲明及其相關告知事項，對於以上條例我們保有最終解釋權。</p>
      <p>九、 聯絡我們</p>
      <p>如果您對於我們的隱私權作法有任何問題或疑慮，請逕行聯絡：service@lulukeep.com</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">確 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import FN from '@/components/fn'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'dialog',
  components: {
  },
  mixins: [FN],
  props: {
    data: Object
  },
  data() {
    return {
      
    }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.$parent.dialogTermsVisible = false
    }
  }
}
</script>
